<template>
  <div class="container">
    <div class="project-page">
      <h1 class="project-page__title"></h1>
      <ProjectItem
        v-for="(project, index) in projects"
        :key="index"
        :name="project.name"
        :description="project.description"
        :image="project.image"
        :videoOptions="project.videoOptions"
        :slug="project.slug"
      />
    </div>
  </div>
</template>

<script>
import ProjectItem from "@/components/ProjectItem.vue";
import store from "@/store.js";

export default {
  name: "Projects",
  components: {
    ProjectItem,
  },
  data() {
    return {
      projects: store.projects,
    };
  },
};
</script>

<style scoped>
.project-page {
  margin-bottom: 64px;
}

.project-page__title {
  margin-bottom: 16px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 48px;
  font-weight: 700;
  text-transform: uppercase;
}
</style>
